import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {UNSET_CONFIG_VARIABLE} from 'pipelines/PipelineConfigConstants';
import {InlineBannerType} from 'ui-library/banners/InlineBanner';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {BANNER_KEY, FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

export const EXPORT_DATA_CATALOG_DATASET_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<
  PipelineStepType.EXPORT_DATA_CATALOG_DATASET,
  0
> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['datasetName', 'folderId'],
  datasetName: {
    displayName: 'Dataset name',
    configShapePath: ['datasetName'],
    infoText: 'Defaults to "<analysis name> / <table name>" if left blank.',
  },
  folderId: {
    displayName: 'Folder',
    configShapePath: ['folderId'],
    disableFn: ({config}) => config.folderId === UNSET_CONFIG_VARIABLE,
    [BANNER_KEY]: {
      text: 'Folder will be selected when the template is run.',
      bannerType: InlineBannerType.INFO,
      placement: 'below',
      visibilityFn: (config) => config.folderId === UNSET_CONFIG_VARIABLE,
    },
  },
};
